export enum EnTheme {
    default = 'default',
    black = 'black'
}
